// extracted by mini-css-extract-plugin
module.exports = {"ActivityIntroduction":"ActivityIntroduction_ActivityIntroduction__RRPt8","ef-box":"ActivityIntroduction_ef-box__3v2Ly"};